export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1440,
} as const;

export const COLORS = {
  PRIMARY: '#8b7355',
  SECONDARY: '#2a2a2a',
  BACKGROUND: '#f9f7f4',
  WHITE: '#ffffff',
  BORDER: '#e8e6e1',
  TEXT_PRIMARY: '#2a2a2a',
  TEXT_SECONDARY: '#6b6b6b',
  ERROR: '#dc3545',
  SUCCESS: '#28a745',
  WARNING: '#ffc107',
  INFO: '#17a2b8',
} as const;

export const ROUTES = {
  HOME: '/',
  CLUBS: '/clubs',
  FEED: '/feed',
  PROFILE: '/profile',
  CLUB_DETAIL: '/club/:slug',
  CLUB_BOARD: '/clubboard/:slug',
  CREATE_CLUB: '/create-club',
  EDIT_CLUB: '/edit-club/:slug',
  WRITE_FEED: '/write/feed',
  WRITE_REVIEW: '/write/review/:scheduleId',
  WRITE_PREPARATION: '/write/preparation/:scheduleId',
  WRITING_HUB: '/writing-hub',
  QNA: '/qna',
  ONBOARDING: '/onboarding',
} as const;

export const CLUB_CATEGORIES = [
  { id: '전체', name: '전체', icon: '📋' },
  { id: '독서/글쓰기', name: '독서/글쓰기', icon: '📚' },
  { id: '문화/예술', name: '문화/예술', icon: '🎨' },
  { id: '라이프/취향', name: '라이프/취향', icon: '🏃' },
  { id: '자기개발/네트워킹', name: '자기개발/네트워킹', icon: '💡' },
  { id: 'AI/코딩', name: 'AI/코딩', icon: '🤖' },
] as const;

export const TOAST_DURATION = 3000;
export const MAX_FILE_SIZE = 5 * 1024 * 1024;
export const MAX_IMAGES = 3;
